/**
 * Rounds credits to the cent, as the ledger keeps them, so a balance with
 * halves minus a cost doesn't show float crumbs (2.3 - 1 = 1.2999…).
 * @param amount - Credits, possibly with crumbs.
 * @returns The same credits, to the cent.
 */
export const roundCredits = (amount: number): number => Math.round(amount * 100) / 100;
